import type { ProductConfig } from "./product-config-context";

let currentConfig: ProductConfig = {};
let currentFormData: Record<string, Record<string, unknown>> = {};

export function setProductConfig(config: ProductConfig): void {
  currentConfig = config;
}

export function getProductConfig(): ProductConfig {
  return currentConfig;
}

export function setFormData(
  formData: Record<string, Record<string, unknown>>,
): void {
  currentFormData = formData;
}

export function getFormData(): Record<string, Record<string, unknown>> {
  return currentFormData;
}
